<template>
  <div class="overflow-x-auto">
    <table class="w-full">
      <colgroup>
        <slot name="colgroup" :columns="columns"/>
      </colgroup>
      <thead>
      <tr v-for="(head, hi) in thead">
        <th v-for="(item, h_i) in head" :key="`${item.name}_${item.key}`"
            class="p-0"
            :class="{'border-top': hi > 0, 'border-right': thead.length > 1}"
            :rowspan="item.rowspan"
            :colspan="item.colspan"
            :style="{minWidth: '100px',...item.style}">
          <header-item :index="h_i" :label="item.name" :sort-key="item.key" v-model="sorted"/>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, rowIndex) in list" :key="rowIndex" @click="onClickDetail(row)">
        <td v-if="row.no">{{ row.no }}</td>
        <td v-else-if="Object.keys(row).length > 0">{{ rowIndex + 1 }}</td>
        <td v-else></td>

        <td v-for="(head, index) in columns" :key="`${head.name}_${head.key}`">
          <p>{{ getColumnValue(index, rowIndex, row) }}</p>
        </td>
      </tr>
      </tbody>
    </table>


    <div v-if="list.length === 0">
      <div colspan="100">
        <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px">
          <feather-icon icon="AlertTriangleIcon" class="mr-2"/>
          표시할 데이터가 없습니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import singlePageList from "@/views/boards/single-page/listIndex";
import HeaderItem from "@/views/list/TableListPageTheme/component/HeaderItem.vue";

export default {
  name: "ThemeSimpleTable",
  components: {HeaderItem},
  props: {
    boardId: {
      type: Number,
      required: true,
    },
    list: Array,
    /**
     * 결재 목록인 경우
     */
    approval: Boolean,
    tableOption: Object,
  },
  watch: {
    sorted() {
      this.$emit("sort", this.sorted);
    }
  }, // watch
  computed: {
    myInfo() {
      return this.$store.state.member.memberInfo;
    },
    listInfo() {
      return singlePageList[`${this.boardId}_list`];
    },
    heads() {
      const heads = [
        {
          name: "No.",
          key: "no",
        }
      ];
      // List.js 에 작성한 head 정보를 가져옴
      heads.push(...this.listInfo.getHead(this.tableOption));
      if (this.approval) {
        heads.push({
          name: "결재 상태",
          key: "approval",
        });
      }
      return heads;
    },

    // head 의 rowspan, colspan 을 구하기 위한 로직
    thead() {
      const heads = [[]]
      for (const head of this.heads) {
        const child = head.child;
        if (child) {
          head.childDepth = 1; // rowspan 을 구하기 위해 자식의 depth 를 입력
          head.colspan = child.length;
          delete head.child;
          heads[0].push(head);

          for (const c of child) {
            if (heads.length <= 1) heads[1] = [];
            heads[1].push(c);
          }

        } else {
          head.colspan = 1;
          head.childDepth = 0; // rowspan 을 구하기 위해 자식의 depth 를 입력
          heads[0].push(head);
        }
      }

      // rowspan 을 구하기 위한 로직
      for (let i = 0; i < heads.length; i++) {
        for (const head of heads[i]) {
          head.rowspan = heads.length - head.childDepth;
        }
      }

      return heads;
    },
    // row 의 각 column 에 해당하는 Head 정보
    columns() {
      const columns = []
      for (const head of this.listInfo.getHead(this.tableOption)) {
        const child = head.child;
        if (child) {
          for (const c of child) {
            columns.push(c);
          }
        } else {
          columns.push(head);
        }
      }

      if (this.approval) {
        columns.push({
          name: "결재상태",
          key: "approval",
        });
      }

      return columns;
    },
  }, //computed
  data() {
    return {
      showNav: true,
      sorted: {
        key: "",
        order: "",
      },
    }
  },

  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
  },
  methods: {

    // 각 column 에 해당하는 값을 List.js 에서 가져옴
    getColumnValue(index, rowIndex, value) {
      const memberInfo = this.$store.state.member.memberInfo;
      // getCol 에 전달 될 함수들
      const func = {
        getContent: (data) => {
          if (data.post_content) {
            const content = JSON.parse(data.post_content);
            return content.body;
          }
        },
        getCreatedDate: (data) => {
          if (data === "") return "";
          return new Date(data).format("yyyy-MM-dd");
        },
        onNameBlur: (name) => {
          const length = name.length;
          if (length > 2) {
            const first = name[0];
            const last = name[name.length - 1];
            let star = "";
            for (let index = 0; index < length - 2; index++) {
              star += "*";
            }
            name = first + star + last;
          } else if (length === 2) {
            const first = name[0];
            name = `${first}*`;
          }
          return name;
        },
        comma: (str) => {
          return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        no: () => {
          return rowIndex + 1;
        },
        getAuthUserInfo() {
          return memberInfo;
        },
      };

      if (this.listInfo) {
        const __getCol = (index, value, func) => {
          const head = this.heads[index + 1]; // No. 를 제외한 head 정보
          const keys = head.key.split(".");
          const keysLength = keys.length;
          if (keysLength === 1) {
            if (keys[0] === "created_at") {
              return func.getCreatedDate(value.created_at);
            }
            if (keys[0] === "approval") {
              return value.document_status.name
            }
          }

          if (keysLength > 1) {
            const content = JSON.parse(value.post_content);
            const getData = (keys) => {
              let data = content;
              for (let i = 0; i < keys.length; i++) {
                data = data[keys[i]] || "";
              }
              return data;
            };
            return getData(keys);
          }
        };

        if (this.listInfo.getCol) {
          const result = this.listInfo.getCol(index, value, {
            ...func,
            _getCol: __getCol,
            ...this.tableOption,
          });
          return result;
        } else {
          const data = __getCol(index, value, func);
          if (Array.isArray(data)) {
            return data.join(", ");
          }
          return data;
        }
      }
      return "";
    },


    onClickDetail(item, target = "self") {
      item.postId = item.post_id;
      item.projectId = item.project_id;
      this.$emit("selected", item, target);
    },
  }
}
</script>
<style scoped lang="scss">
table {
  border-collapse: collapse;

  border: 2px solid #F9F9F9;
  border-bottom-width: 3px;

  th {
    padding: 10px 15px;
    font-weight: 600;
    color: #333;
    text-align: center;
  }

  td {
    padding: 0.7rem 1.1rem;
    border-top: 1px solid #F9F9F9;
    color: #666;
    text-align: center;
  }

  thead {
    th {
      &.border-top {
        border-top: 3px solid #F9F9F9 !important;
      }

      &.border-right {
        border-right: 3px solid #F9F9F9 !important;
      }
    }
  }

  tbody {
    background: #f8f8f8;

    tr {
      cursor: pointer;
      transition: all .3s ease;
      background-color: #FFFFFF;

      &:hover {
        transform: translateY(-4px);
      }
    }

    tr:nth-child(Odd) {
      background-color: #F9F9F9;
    }
  }
}
</style>

